import { Tooltip } from 'antd';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { useThrottleTempFix } from '../../../../../hooks/useThrottleTempFix';

const Main = styled.div`
  display: grid;
  place-items: center;
  font-size: 24px;
  line-height: 0;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: ${colorsV2.black100};

  &:hover {
    background-color: ${colorsV2.black10};
  }
  &.active {
    background-color: ${colorsV2.primary10};
    color: ${colorsV2.primary100};
  }
  &:disabled,
  &.disabled {
    cursor: not-allowed;
    background-color: transparent;
    color: ${colorsV2.gray40};
  }
`;

interface MarkButtonProps {
  icon: JSX.Element;
  disabled?: boolean;
  active?: boolean;
  onMouseDown: (e) => void;
  tooltipPlacement?: 'left' | 'right';
  name?: string;
  popOverMenu?: any;
}

export const MarkButton = (props: MarkButtonProps) => {
  const { icon, disabled, active, onMouseDown, tooltipPlacement, name, popOverMenu, ...rest } =
    props;
  const [isPopOverVisible, setPopOverVisible] = React.useState(false);
  const [isHover, setIsHover] = React.useState(false);
  const throttledHover = useThrottleTempFix(isHover, 300);
  const shouldShowTooltip =
    Boolean(tooltipPlacement) && !isPopOverVisible && !disabled && throttledHover;
  const renderPopover = React.useCallback(() => {
    if (disabled) return null;
    if (typeof popOverMenu === 'function') {
      return popOverMenu({ setPopOverVisible });
    }
    return popOverMenu;
  }, [disabled, popOverMenu]);
  return (
    <Tooltip
      destroyTooltipOnHide
      classNames={{ root: 'unstyled overlay-no-padding tooltip-no-arrow' }}
      open={isPopOverVisible}
      placement={tooltipPlacement}
      title={renderPopover()}
    >
      <Tooltip open={shouldShowTooltip} placement={tooltipPlacement} title={name}>
        <div
          onMouseEnter={() => {
            setIsHover(true);
          }}
          onMouseLeave={() => {
            setIsHover(false);
          }}
          aria-hidden
          onMouseDown={onMouseDown}
          className="group-mark-action-item"
        >
          <Main
            onClick={() => {
              setPopOverVisible(true);
            }}
            className={cl('mark-button', { disabled, active })}
            {...rest}
          >
            <div className="icon">{icon}</div>
          </Main>
        </div>
      </Tooltip>
    </Tooltip>
  );
};
